import { Component, AfterViewInit, Input } from '@angular/core'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-adsense-inarticle',
  templateUrl: './adsense-inarticle.component.html',
  styleUrls: ['./adsense-inarticle.component.scss'],
})

/* inarticle 넣으면 흰 화면 되는 이슈 */
export class AdsenseInarticleComponent implements AfterViewInit {
  constructor() {}
  @Input() adSlot: string = ''
  isProduction = environment.production
  ngAfterViewInit() {
    setTimeout(() => {
      try {
        ;(window['adsbygoogle'] = window['adsbygoogle'] || []).push({})
      } catch (e) {
        console.error('error')
      }
    }, 2000)
  }
}
